import { InvitationTypes } from '@/enums/invitationTypes.enum';
import { acceptResource, AcceptResource } from '@/resources/accept.resource';
import { teamResource } from '@/resources/team.resource';
import { AbstractModule } from './abstract.module';

/**
 * Moduł akceptacji zaproszeń
 *
 * @class AcceptModule
 * @extends {AbstractModule<AcceptResource>}
 */
class AcceptModule extends AbstractModule<AcceptResource> {
  public state = {
    message: undefined
  };

  public mutations = {
    /**
     * Ustawia treść zaproszenia
     *
     * @param {*} localState
     * @param {string} message
     */
    setMessage(localState: any, message: string): void {
      localState.message = message;
    }
  };

  public actions = {
    /**
     * Ustala treść zaproszenia na podstawie tokenu
     *
     * @memberof AcceptModule
     */
    getMessage: async (context: any, data: { token: string; invitationType: InvitationTypes }) => {
      let message;
      if (data.invitationType === InvitationTypes.COACH || data.invitationType === InvitationTypes.PLAYER) {
        message = await teamResource
          .getByToken(data.token)
          .then(
            team =>
              `Zostałeś zaproszony do ${
                data.invitationType === InvitationTypes.COACH ? 'trenowania' : ''
              } grupy treningowej ${team.name} klubu ${team.club.name}.`
          );
      } else if (data.invitationType === InvitationTypes.PARENT) {
        message = 'Zostałeś zaproszony do bycia rodzicem.';
      } else {
        message = 'Zostałeś zaproszony do bycia dzieckiem.';
      }
      context.commit('setMessage', message);
    }
  };
}

export default new AcceptModule(acceptResource);
